var React = require('react');

function CheckIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9 0C4.03385 0 0 4.03385 0 9C0 13.9662 4.03385 18 9 18C13.9662 18 18 13.9662 18 9C18 4.03385 13.9662 0 9 0ZM9 16.6154C4.8 16.6154 1.38462 13.2 1.38462 9C1.38462 4.8 4.8 1.38462 9 1.38462C13.2 1.38462 16.6154 4.8 16.6154 9C16.6154 13.2 13.2 16.6154 9 16.6154Z","fill":"#C0FFAA","key":0}),React.createElement("path",{"d":"M12.2026 6.66464L8.07642 10.7908L5.79642 8.51079C5.52873 8.2431 5.08565 8.2431 4.81796 8.51079C4.55026 8.77848 4.55026 9.22156 4.81796 9.48925L7.58719 12.2585C7.72565 12.3969 7.90103 12.4616 8.07642 12.4616C8.2518 12.4616 8.42719 12.3969 8.56565 12.2585L13.181 7.6431C13.4487 7.37541 13.4487 6.93233 13.181 6.66464C12.9133 6.39694 12.4703 6.39694 12.2026 6.66464Z","fill":"#C0FFAA","key":1})]);
}

CheckIcon.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = CheckIcon;

CheckIcon.default = CheckIcon;
